import { state } from './moduleHomePageState';
import { actions } from './moduleHomePageActions';
import { mutations } from './moduleHomePageMutations';
import { getters } from './moduleHomePageGetters';

export const moduleHomePage = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
}